// 宮崎県農業クイズ100問
export const quizData = [
  // 第1部 畜産大国の神髄 - A. 宮崎牛 (問1-20)
  {
    id: 1,
    category: "宮崎牛",
    question: "「宮崎牛」と公式に称することができるのは、日本食肉格付協会が定める肉質等級がどの基準を満たしたものでしょうか？",
    options: [
      "3等級以上",
      "4等級以上",
      "5等級のみ",
      "A5ランクのみ"
    ],
    correctAnswer: 1,
    explanation: "「宮崎牛」と認定されるには、肉質等級が4等級または5等級であることが必須条件です。肉質等級は「脂肪交雑」「肉の色沢」「肉の締まり及びきめ」「脂肪の色沢と質」の4項目で評価され、これら全てで4以上の評価を得なければなりません。"
  },
  {
    id: 2,
    category: "宮崎牛",
    question: "宮崎牛は、5年に一度開催される全国和牛能力共進会（通称：和牛のオリンピック）において、史上初となる快挙を成し遂げました。その内容とは何でしょうか？",
    options: [
      "2大会連続で内閣総理大臣賞を受賞",
      "3大会連続で内閣総理大臣賞を受賞",
      "4大会連続で内閣総理大臣賞を受賞",
      "5大会連続で内閣総理大臣賞を受賞"
    ],
    correctAnswer: 2,
    explanation: "宮崎牛は、第9回（2007年）、第10回（2012年）、第11回（2017年）、そして第12回（2022年）と、史上初となる4大会連続で最高賞である内閣総理大臣賞を受賞しました。"
  },
  {
    id: 3,
    category: "宮崎牛",
    question: "宮崎牛の定義には、肉質等級の他に血統に関する規定があります。その規定として正しいものはどれでしょうか？",
    options: [
      "県内で生まれた純粋な黒毛和種であること",
      "父親が必ず宮崎県産の種雄牛であること",
      "県内種雄牛、または指定された種雄牛を祖先に持つこと",
      "母親が3代にわたり宮崎県内で飼育されていること"
    ],
    correctAnswer: 2,
    explanation: "宮崎牛の定義には、「県内種雄牛、もしくは家畜改良のため指定された種雄牛を一代祖にもつもの」という血統に関する規定があります。"
  },
  {
    id: 4,
    category: "宮崎牛",
    question: "肉質等級を決定する4つの評価項目のうち、「サシ」の入り具合を評価する項目は何と呼ばれているでしょうか？",
    options: [
      "脂肪品質",
      "脂肪交雑",
      "霜降り度",
      "筋肉内脂肪"
    ],
    correctAnswer: 1,
    explanation: "「脂肪交雑」は、赤身の筋肉の中にある脂肪の入り具合、いわゆる「サシ」や「霜降り」を評価する項目です。"
  },
  {
    id: 5,
    category: "宮崎牛",
    question: "2005年に行われた宮崎牛の定義見直しにおいて、どのような変更が加えられたでしょうか？",
    options: [
      "飼育期間が6ヶ月延長された",
      "対象が黒毛和種から交雑種にも拡大された",
      "認定基準が肉質等級3等級以上から4等級以上に引き上げられた",
      "認定にDNA鑑定が義務付けられた"
    ],
    correctAnswer: 2,
    explanation: "2005年、宮崎牛のブランド価値をさらに高めるため、認定基準が3等級以上から4等級と5等級のみに厳格化されました。"
  },
  {
    id: 6,
    category: "宮崎牛",
    question: "宮崎牛の定義において、牛の生まれと育ちに関する重要な条件とは何でしょうか？",
    options: [
      "宮崎県内で生まれ、県外で肥育された黒毛和種",
      "県外で生まれ、宮崎県内で最も長く飼育された黒毛和種",
      "宮崎県内で生まれ育ち、最長飼養地が宮崎県である黒毛和種",
      "親牛が宮崎県生まれであれば、飼育地は問わない"
    ],
    correctAnswer: 2,
    explanation: "宮崎牛は、「宮崎県内で出生し、宮崎県内で肥育された黒毛和種」であり、かつ「最長飼養地（生涯で最も長く飼育された場所）が宮崎県であること」が条件です。"
  },
  {
    id: 7,
    category: "宮崎牛",
    question: "第12回全国和牛能力共進会で宮崎牛が内閣総理大臣賞を受賞した際、特に高く評価されたのはどの部門でしょうか？",
    options: [
      "肉の旨味成分評価群",
      "脂肪の質評価群",
      "赤身の柔らかさ評価群",
      "骨格の発達評価群"
    ],
    correctAnswer: 1,
    explanation: "第12回大会では、宮崎県代表牛が第7区（脂肪の質評価群）で優等賞首席となり、これが評価されて内閣総理大臣賞を受賞しました。"
  },
  {
    id: 8,
    category: "宮崎牛",
    question: "肉質等級を決定する4つの評価項目のうち、肉の色の鮮やかさや光沢を評価する項目はどれでしょうか？",
    options: [
      "肉の色沢",
      "肉の光沢",
      "肉の鮮度",
      "肉の彩度"
    ],
    correctAnswer: 0,
    explanation: "「肉の色沢（しきたく）」は、肉の色合いと光沢を評価する項目です。鮮やかな赤色で、つやがあるものが高く評価されます。"
  },
  {
    id: 9,
    category: "宮崎牛",
    question: "JA宮崎経済連が宮崎牛のプロモーションとして展開した「世界遺産 by 宮崎牛」キャンペーンで、フードアートとして再現されなかった世界遺産はどれでしょうか？",
    options: [
      "ピラミッド",
      "グランドキャニオン",
      "マチュピチュ",
      "富士山"
    ],
    correctAnswer: 2,
    explanation: "このキャンペーンでは、ピラミッド、グランドキャニオン、富士山などが宮崎牛で再現されましたが、マチュピチュは含まれていません。"
  },
  {
    id: 10,
    category: "宮崎牛",
    question: "宮崎牛が4大会連続で内閣総理大臣賞を受賞した「全国和牛能力共進会」は、およそ何年に一度開催される大会でしょうか？",
    options: [
      "2年に一度",
      "3年に一度",
      "5年に一度",
      "10年に一度"
    ],
    correctAnswer: 2,
    explanation: "全国和牛能力共進会は、原則として5年に一度開催される、和牛業界にとって最も重要なイベントです。"
  },
  {
    id: 11,
    category: "宮崎牛",
    question: "肉質等級の格付けは、どのような資格を持つ人物によって行われるでしょうか？",
    options: [
      "獣医師",
      "農学博士",
      "国家資格を持つ検査員",
      "県が認定した専門職員"
    ],
    correctAnswer: 2,
    explanation: "食肉の格付けは、国家資格を持つ（公社）日本食肉格付協会の格付員（検査員）によって、一頭一頭厳正に行われます。"
  },
  {
    id: 12,
    category: "宮崎牛",
    question: "宮崎牛の定義において、「最長飼養地が宮崎県」という条件が意味することは何でしょうか？",
    options: [
      "生涯のうち最も長く宮崎県で飼育されていること",
      "出荷前の一定期間、宮崎県で飼育されていること",
      "母親が宮崎県で飼育されていたこと",
      "飼料の半分以上が宮崎県産であること"
    ],
    correctAnswer: 0,
    explanation: "この条件は、牛がその生涯の大半を宮崎の風土と環境のもとで過ごしたことを保証するものです。"
  },
  {
    id: 13,
    category: "宮崎牛",
    question: "肉質等級を決定する4つの評価項目のうち、肉の弾力や繊維の細かさを評価する項目はどれでしょうか？",
    options: [
      "肉の締まり及びきめ",
      "肉の弾力及び繊維",
      "肉の保水性及び密度",
      "肉の熟成度及び構造"
    ],
    correctAnswer: 0,
    explanation: "「肉の締まり及びきめ」では、肉の身が引き締まっているか、そして肉の繊維（きめ）が細かいかを評価します。"
  },
  {
    id: 14,
    category: "宮崎牛",
    question: "宮崎牛は、ある特定の和牛の品種に限定されています。その品種名は何でしょうか？",
    options: [
      "黒毛和種",
      "褐毛和種",
      "日本短角種",
      "無角和種"
    ],
    correctAnswer: 0,
    explanation: "宮崎牛は「黒毛和種（くろげわしゅ）」に限定されています。黒毛和種は、サシが入りやすく、肉質が優れていることで知られています。"
  },
  {
    id: 15,
    category: "宮崎牛",
    question: "第12回全国和牛能力共進会が開催された都道府県はどこでしょうか？",
    options: [
      "宮崎県",
      "鹿児島県",
      "北海道",
      "兵庫県"
    ],
    correctAnswer: 1,
    explanation: "第12回全国和牛能力共進会は、2022年10月に隣県の鹿児島県で開催されました。"
  },
  {
    id: 16,
    category: "宮崎牛",
    question: "宮崎牛の肉質等級が「4等級」と格付けされるためには、4つの評価項目がどのようになっている必要があるでしょうか？",
    options: [
      "4項目の平均が4以上である",
      "4項目のうち3項目が4以上である",
      "4項目すべてが4以上の評価である",
      "脂肪交雑のみが4以上であればよい"
    ],
    correctAnswer: 2,
    explanation: "肉質等級4等級以上と認定されるためには、4項目すべてにおいて、5段階評価で4以上の評価を得る必要があります。"
  },
  {
    id: 17,
    category: "宮崎牛",
    question: "全国和牛能力共進会の各区で最も優秀な牛に与えられる「優等賞首席」には、どの賞が授与されるでしょうか？",
    options: [
      "内閣総理大臣賞",
      "天皇賜杯",
      "農林水産大臣賞",
      "宮崎県知事賞"
    ],
    correctAnswer: 2,
    explanation: "全国和牛能力共進会の各審査区で最も優秀と評価された優等賞首席には、農林水産大臣賞が授与されます。"
  },
  {
    id: 18,
    category: "宮崎牛",
    question: "全国和牛能力共進会で最高位の名誉賞とされる「内閣総理大臣賞」は、どのようにして選ばれるでしょうか？",
    options: [
      "全ての出品牛の中から直接選ばれる",
      "種牛の部と肉牛の部の優等賞首席の中からそれぞれ選ばれる",
      "来場者の投票によって選ばれる",
      "海外の審査員の評価によって選ばれる"
    ],
    correctAnswer: 1,
    explanation: "内閣総理大臣賞は、種牛の部（牛の改良成果を評価）と肉牛の部（枝肉の品質を評価）のそれぞれの優等賞首席の中から、最も優れた牛に1点ずつ授与されます。"
  },
  {
    id: 19,
    category: "宮崎牛",
    question: "宮崎牛のブランド価値を高めるために2005年に行われた基準の厳格化は、どのような市場戦略を反映していると考えられるでしょうか？",
    options: [
      "生産量を増やし、価格を下げる戦略",
      "輸出量を増やすため、海外基準に合わせる戦略",
      "品質を最高レベルに特化させ、高級ブランドとしての地位を確立する戦略",
      "飼育農家の負担を減らし、参入障壁を下げる戦略"
    ],
    correctAnswer: 2,
    explanation: "2005年の基準厳格化は、量を追うのではなく、「宮崎牛＝最高級」というイメージを市場と消費者に強く印象付けるための戦略的な決断でした。"
  },
  {
    id: 20,
    category: "宮崎牛",
    question: "宮崎牛の定義に含まれる「県内種雄牛」とは、どのような牛を指すでしょうか？",
    options: [
      "宮崎県内で生まれ育った雄牛全般",
      "宮崎県が家畜改良の目的で選抜・指定した特に優れた雄牛",
      "全国和牛能力共進会で入賞した経験のある雄牛",
      "3歳未満の若い雄牛"
    ],
    correctAnswer: 1,
    explanation: "「県内種雄牛」とは、宮崎県が和牛の品質を向上させるための育種改良計画に基づき、厳格な審査を経て選抜したエリートの種雄牛を指します。"
  },

  // B. みやざき地頭鶏 (問21-35)
  {
    id: 21,
    category: "みやざき地頭鶏",
    question: "宮崎県のブランド地鶏「みやざき地頭鶏」の名前の由来となった「地頭鶏（じとっこ）」は、どのような歴史的背景を持つ鶏でしょうか？",
    options: [
      "闘鶏として非常に強かったため",
      "非常に美味しく、地頭職に献上されていたため",
      "頭の羽が特徴的な形をしていたため",
      "神社の使いとして飼育されていたため"
    ],
    correctAnswer: 1,
    explanation: "江戸時代に、宮崎県や鹿児島県の旧島津領で飼育されていた在来種は、その肉が非常に美味しかったため、農家の人々がその土地の領主である地頭職に献上していたことから、「地頭鶏」と呼ばれるようになりました。"
  },
  {
    id: 22,
    category: "みやざき地頭鶏",
    question: "「みやざき地頭鶏」の飼育基準において、1平方メートルあたりの飼育羽数は何羽以下と定められているでしょうか？",
    options: [
      "2羽以下",
      "5羽以下",
      "8羽以下",
      "10羽以下"
    ],
    correctAnswer: 0,
    explanation: "「みやざき地頭鶏」は、広々とした環境で飼育されます。飼育密度は1平方メートルあたり2羽以下と、国の地鶏飼育基準（10羽以下）よりもはるかに厳しい基準が定められています。"
  },
  {
    id: 23,
    category: "みやざき地頭鶏",
    question: "「みやざき地頭鶏」の雄のおおよその飼育期間として、基準で定められているのはどれでしょうか？",
    options: [
      "約2ヶ月（60日）",
      "約3ヶ月（90日）",
      "約4ヶ月（120日）",
      "約6ヶ月（180日）"
    ],
    correctAnswer: 2,
    explanation: "一般的なブロイラーが約50日で出荷されるのに対し、「みやざき地頭鶏」は雄でおおむね4ヶ月（約120日）という長い期間をかけてじっくりと飼育されます。"
  },
  {
    id: 24,
    category: "みやざき地頭鶏",
    question: "「みやざき地頭鶏」の開発過程で、産卵率などを向上させるために交配に用いられた、熊本・大分・宮崎の3県で共同開発された地鶏の名称は何でしょうか？",
    options: [
      "九州キング",
      "九州ロード",
      "九州プライド",
      "九州サンシャイン"
    ],
    correctAnswer: 1,
    explanation: "「みやざき地頭鶏」の開発過程で、1998年に「九州ロード」という鶏が交配に用いられました。これにより生産性が大きく向上しました。"
  },
  {
    id: 25,
    category: "みやざき地頭鶏",
    question: "「みやざき地頭鶏」の原種である「地頭鶏」は、その希少性から昭和18年（1943年）に国から何に指定されたでしょうか？",
    options: [
      "重要文化財",
      "特別天然記念物",
      "天然記念物",
      "絶滅危惧種"
    ],
    correctAnswer: 2,
    explanation: "純粋な「地頭鶏」は、生産羽数が非常に少なく希少なため、昭和18年（1943年）に文部省（当時）から国の天然記念物に指定されました。"
  },
  {
    id: 26,
    category: "みやざき地頭鶏",
    question: "「みやざき地頭鶏」の飼育方法として、基準で定められているのはどれでしょうか？",
    options: [
      "全期間ケージ飼育",
      "全期間平飼い飼育",
      "最初の1ヶ月のみケージ飼育",
      "出荷前の1ヶ月のみ放し飼い"
    ],
    correctAnswer: 1,
    explanation: "育すう期（ひなを育てる期間）を含め、全期間にわたって地面を自由に動き回れる「平飼い」で飼育することが義務付けられています。"
  },
  {
    id: 27,
    category: "みやざき地頭鶏",
    question: "「みやざき地頭鶏」という名称が正式に定められたのは西暦何年でしょうか？",
    options: [
      "1985年",
      "1998年",
      "2004年",
      "2009年"
    ],
    correctAnswer: 2,
    explanation: "宮崎県では1985年から地鶏の開発を進めていましたが、2004年に、その歴史的背景と特徴をより明確に伝えるため、「みやざき地頭鶏」と改名されました。"
  },
  {
    id: 28,
    category: "みやざき地頭鶏",
    question: "「みやざき地頭鶏」は、地鶏の生産量において全国トップクラスですが、平成24年度の統計では全国第何位になったでしょうか？",
    options: [
      "第1位",
      "第2位",
      "第3位",
      "第5位"
    ],
    correctAnswer: 2,
    explanation: "平成24年度の統計によると、「みやざき地頭鶏」の生産羽数は、徳島県の「阿波尾鶏」、愛知県の「名古屋コーチン」に次いで全国第3位となりました。"
  },
  {
    id: 29,
    category: "みやざき地頭鶏",
    question: "「みやざき地頭鶏」の肉質の特徴として、しばしば「弾力のある柔らかさ」と表現されますが、これはどのような飼育方法によってもたらされると考えられているでしょうか？",
    options: [
      "短期間で集中的に肥育する",
      "栄養価の高い特殊な飼料を与える",
      "長い飼育期間と広々とした環境で育てる",
      "飼育中に定期的な運動をさせる"
    ],
    correctAnswer: 2,
    explanation: "「みやざき地頭鶏」の特長である、ただ柔らかいだけでなく、しっかりとした弾力と歯ごたえを併せ持つ肉質は、長い飼育期間と、広々とした環境で十分に運動できることによって形成されます。"
  },
  {
    id: 30,
    category: "みやざき地頭鶏",
    question: "「みやざき地頭鶏」の開発が宮崎県畜産試験場で開始されたのは西暦何年でしょうか？",
    options: [
      "1975年",
      "1985年",
      "1995年",
      "2005年"
    ],
    correctAnswer: 1,
    explanation: "宮崎県の地域性を持つ地鶏を開発するプロジェクトは、1985年に宮崎県畜産試験場川南支場でスタートしました。"
  },
  {
    id: 31,
    category: "みやざき地頭鶏",
    question: "「みやざき地頭鶏」のブランドは、2010年に特許庁からある重要な登録を受けています。それは何でしょうか？",
    options: [
      "発明特許",
      "意匠登録",
      "地域団体商標登録",
      "実用新案登録"
    ],
    correctAnswer: 2,
    explanation: "「みやざき地頭鶏」は、2010年に特許庁から地域団体商標として登録されました。これは、地域ブランドとして法的に保護され、その品質と信頼性が公に認められたことを意味します。"
  },
  {
    id: 32,
    category: "みやざき地頭鶏",
    question: "「みやざき地頭鶏」の雌のおおよその飼育期間として、基準で定められているのはどれでしょうか？",
    options: [
      "約3ヶ月（90日）",
      "約4ヶ月（120日）",
      "約5ヶ月（150日）",
      "約6ヶ月（180日）"
    ],
    correctAnswer: 2,
    explanation: "「みやざき地頭鶏」の雌は、雄よりもさらに長い、おおむね5ヶ月（約150日）の期間をかけて飼育されます。これにより、より成熟した深い味わいが生まれます。"
  },
  {
    id: 33,
    category: "みやざき地頭鶏",
    question: "「みやざき地頭鶏」の開発初期において、産卵率の低さなどの課題を解決するために導入された「九州ロード」は、主にどの性別が交配に用いられたでしょうか？",
    options: [
      "雄鶏（父鶏）",
      "雌鶏（母鶏）",
      "雄雌両方",
      "特定されていない"
    ],
    correctAnswer: 1,
    explanation: "開発過程では、美味しさの源である地頭鶏を父鶏とし、産卵率が高く強健な「九州ロード」を母鶏として交配する様式が確立されました。"
  },
  {
    id: 34,
    category: "みやざき地頭鶏",
    question: "「地頭鶏」が古くから飼育されてきたのは、宮崎県と現在のどの県の旧島津領地でしょうか？",
    options: [
      "熊本県",
      "大分県",
      "鹿児島県",
      "福岡県"
    ],
    correctAnswer: 2,
    explanation: "地頭鶏は、宮崎県と鹿児島県の霧島山麓にまたがる旧島津藩の領地で、古くから飼育されてきた在来種です。"
  },
  {
    id: 35,
    category: "みやざき地頭鶏",
    question: "「みやざき地頭鶏」の生産は、特定の農家のみに許可されています。この計画的な生産体制を支えるために、県は生産者に対して何を行っているでしょうか？",
    options: [
      "飼料の無償提供",
      "親鶏を管理し、雛鶏を供給",
      "販売価格の全額保証",
      "土地の無償貸与"
    ],
    correctAnswer: 1,
    explanation: "「みやざき地頭鶏」の品質を維持し、ブランドを守るため、宮崎県が種鶏（親鶏）を厳格に管理し、認定された生産農家（指定農場）にのみ雛鶏を供給する体制がとられています。"
  },

  // C. 宮崎ブランドポーク (問36-45)
  {
    id: 36,
    category: "宮崎ブランドポーク",
    question: "「宮崎ブランドポーク」とは、単一の銘柄ではなく、ある制度によって認定された豚肉の総称です。その制度とは何でしょうか？",
    options: [
      "生産者コンテスト制度",
      "指定生産者・指定店制度",
      "血統登録制度",
      "環境認証制度"
    ],
    correctAnswer: 1,
    explanation: "「宮崎ブランドポーク」は、宮崎県が設けた安全・安心に関する基準をクリアした「指定生産者」が生産し、衛生管理の徹底された食肉処理場を経て、「指定店」で販売される豚肉の統一ブランドです。"
  },
  {
    id: 37,
    category: "宮崎ブランドポーク",
    question: "宮崎ブランドポークの一つ「おいも豚」は、その名の通り、飼料にある作物を添加していることが特徴です。その作物とは何でしょうか？",
    options: [
      "さつまいも（おいも）と大麦",
      "じゃがいもとトウモロコシ",
      "里芋と米ぬか",
      "長芋と大豆"
    ],
    correctAnswer: 0,
    explanation: "「おいも豚」は、飼料にさつまいも（おいも）と大麦をバランス良く配合して与えることで、肉の旨味を引き出し、風味豊かな豚肉に仕上げています。"
  },
  {
    id: 38,
    category: "宮崎ブランドポーク",
    question: "高度な水処理技術「RO膜」を用いて浄水した「きれいな水」を豚に与えて育てられる宮崎ブランドポークの銘柄は何でしょうか？",
    options: [
      "観音池ポーク",
      "尾鈴豚",
      "宮崎きれいポーク",
      "はまゆう豚"
    ],
    correctAnswer: 2,
    explanation: "「宮崎きれいポーク」は、逆浸透膜（RO膜）という高度な浄水技術で作られた、不純物をほとんど含まない「きれいな水」を飲ませて育てられています。"
  },
  {
    id: 39,
    category: "宮崎ブランドポーク",
    question: "飼料に甘藷（かんしょ）を加えることで、脂身が甘く、肉質が柔らかい豚肉に仕上げた宮崎ブランドポークの銘柄は何でしょうか？",
    options: [
      "まるみ豚",
      "かんしょ豚",
      "宮崎米寿ポーク",
      "霧島三元豚"
    ],
    correctAnswer: 1,
    explanation: "「かんしょ豚」は、飼料にさつまいも（甘藷）を加えています。さつまいもを与えることで、脂身に自然な甘さが加わり、肉質全体が柔らかくなるのが特徴です。"
  },
  {
    id: 40,
    category: "宮崎ブランドポーク",
    question: "生後75日頃から出荷まで、飼料に米粉を約10%配合することで、もちもちとした食感を生み出している宮崎ブランドポークの銘柄は何でしょうか？",
    options: [
      "はざまのきなこ豚",
      "愛豚隊",
      "宮崎米寿ポーク",
      "美咲豚"
    ],
    correctAnswer: 2,
    explanation: "「宮崎米寿ポーク」は、飼料用米の米粉を約10%配合した餌で育てられます。米を与えることで、肉の食感が「もちもち」とし、脂身はあっさりとして、臭みが少ない豚肉になります。"
  },
  {
    id: 41,
    category: "宮崎ブランドポーク",
    question: "自然由来の炭素飼料「ネッカリッチ」とパン粉を配合した飼料を与えることで、豚肉特有の臭みをなくし、甘みを引き出している銘柄はどれでしょうか？",
    options: [
      "観音池ポーク",
      "尾鈴ポーク",
      "まつばらさんちの豚",
      "はまゆう豚"
    ],
    correctAnswer: 0,
    explanation: "「観音池ポーク」は、豚の健康を考え、自然由来の炭素飼料「ネッカリッチ」と、食品ロス削減にも貢献するパン粉を主原料としたエコフィードを配合した飼料を与えています。"
  },
  {
    id: 42,
    category: "宮崎ブランドポーク",
    question: "微生物・酵素・酵母を配合した特別な餌を与えることで、健康で柔らかな肉質を実現している宮崎ブランドポークの銘柄は何でしょうか？",
    options: [
      "はまゆう豚",
      "宮崎きれいポーク",
      "おいも豚",
      "かんしょ豚"
    ],
    correctAnswer: 0,
    explanation: "「はまゆう豚」は、微生物・酵素・酵母などを配合した特殊な飼料を与えることで、豚の腸内環境を整え、健康に育てています。その結果、ジューシーで優しい味わいの柔らかな肉質が特徴となっています。"
  },
  {
    id: 43,
    category: "宮崎ブランドポーク",
    question: "宮崎県川南町・都農町で養豚を営む7戸の家族が構成するグループが、家族のように豚を大切に育てているブランド名は何でしょうか？",
    options: [
      "チーム宮崎",
      "愛豚隊",
      "七福ポーク",
      "家族の豚"
    ],
    correctAnswer: 1,
    explanation: "「愛豚隊」は、特定の銘柄ではなく、川南町と都農町の7つの養豚農家が結成したグループのブランドです。「家族を愛し、豚を愛する」をモットーに、一頭一頭に愛情を込めて育てた豚肉を供給しています。"
  },
  {
    id: 44,
    category: "宮崎ブランドポーク",
    question: "宮崎ブランドポークの制度が目指している最も重要な目的の一つは何でしょうか？",
    options: [
      "全ての豚肉の価格を統一すること",
      "生産から販売まで一貫した体制で、消費者に安全・安心な豚肉を届けること",
      "海外への輸出量を最大化すること",
      "特定の品種のみを飼育するよう義務付けること"
    ],
    correctAnswer: 1,
    explanation: "宮崎ブランドポーク制度の根幹にあるのは、消費者の信頼を得ることです。指定生産者、衛生的な処理場、指定販売店という一貫した流通管理体制を構築することで、トレーサビリティを確保し、安全で安心な高品質の豚肉を安定的に供給することを目指しています。"
  },
  {
    id: 45,
    category: "宮崎ブランドポーク",
    question: "宮崎県は豚の飼養頭数・出荷頭数で全国トップクラスですが、農林水産省の資料によると、宮崎県の豚肉はどのような特徴を持つと紹介されているでしょうか？",
    options: [
      "主に加工用として高い評価を得ている",
      "赤身の多さが特徴である",
      "「宮崎ブランドポーク」として、安全安心で高品質な豚肉を供給している",
      "日本古来の希少品種の保存に成功している"
    ],
    correctAnswer: 2,
    explanation: "農林水産省の資料でも、宮崎県の豚肉は「宮崎ブランドポーク」という統一ブランドのもと、安全・安心で高品質な豚肉として認知されていることが紹介されています。"
  },

  // 第2部 太陽の国の恵み - A. 太陽の恵み - 果物 (問46-60)
  {
    id: 46,
    category: "果物",
    question: "宮崎県の特産品「太陽のタマゴ」は、ある果物の最高級ブランド名です。その果物とは何でしょうか？",
    options: [
      "マンゴー",
      "ライチ",
      "パパイヤ",
      "日向夏"
    ],
    correctAnswer: 0,
    explanation: "「太陽のタマゴ」は、宮崎県産の完熟マンゴーの中でも、特に厳しい基準をクリアした最高級品にのみ与えられるブランド名です。"
  },
  {
    id: 47,
    category: "果物",
    question: "最高級ブランド「太陽のタマゴ」として認定されるための糖度の基準は、何パーセント（度）以上でしょうか？",
    options: [
      "糖度12度以上",
      "糖度13度以上",
      "糖度15度以上",
      "糖度18度以上"
    ],
    correctAnswer: 2,
    explanation: "「太陽のタマゴ」と認定されるには、糖度が15度以上であることが必須条件です。これは一般的なメロンに匹敵する、あるいはそれ以上の甘さです。"
  },
  {
    id: 48,
    category: "果物",
    question: "「太陽のタマゴ」に認定されるためには、糖度の他に重さの基準もあります。その基準とは何グラム以上でしょうか？",
    options: [
      "250g以上",
      "350g以上",
      "450g以上",
      "500g以上"
    ],
    correctAnswer: 1,
    explanation: "糖度に加え、重さが350g以上（階級では2Lサイズ以上）であることも「太陽のタマゴ」の基準の一つです。"
  },
  {
    id: 49,
    category: "果物",
    question: "宮崎県の完熟マンゴーは、収穫方法に大きな特徴があります。それはどのような方法でしょうか？",
    options: [
      "熟す前に収穫し、追熟させる",
      "樹上で完熟し、自然に落果するのを待つ",
      "一つ一つ手で触って熟度を確認し、収穫する",
      "専用の機械で糖度を測定しながら収穫する"
    ],
    correctAnswer: 1,
    explanation: "宮崎の完熟マンゴーは、ハサミで収穫するのではなく、樹になったまま完全に熟させ、自然にポトリと枝から落ちたものを、あらかじめかけておいたネットで受け止めて収穫します。"
  },
  {
    id: 50,
    category: "果物",
    question: "宮崎県産の完熟きんかんの中でも、糖度16度以上、直径28mm以上の基準を満たしたもののブランド名は何でしょうか？",
    options: [
      "ひなたきんかん",
      "たまたま",
      "こんじき",
      "まるかじり"
    ],
    correctAnswer: 1,
    explanation: "宮崎県産の完熟きんかんのうち、糖度16度以上、直径28mm（Lサイズ）以上という厳しい基準をクリアしたものだけが「たまたま」というブランド名で出荷されます。"
  },
  {
    id: 51,
    category: "果物",
    question: "完熟きんかん「たまたま」の中でも、さらに厳しい基準（糖度18度以上、直径33mm以上）をクリアした最高級品のブランド名は何でしょうか？",
    options: [
      "たまたまプレミアム",
      "たまたまゴールド",
      "たまたまエクセレント",
      "たまたまロイヤル"
    ],
    correctAnswer: 2,
    explanation: "「たまたま」の中でも、さらに糖度が18度以上、直径が33mm（2Lサイズ）以上という、極めて厳しい基準を満たしたものは、「たまたまエクセレント」として出荷されます。"
  },
  {
    id: 52,
    category: "果物",
    question: "宮崎県原産の柑橘「日向夏」の最も特徴的な食べ方として推奨されているのは、次のうちどれでしょうか？",
    options: [
      "外皮を全てむき、果肉だけを食べる",
      "外皮ごとスライスして食べる",
      "黄色い外皮だけを薄くむき、白いワタ（アルベド）と一緒に食べる",
      "果汁を絞ってジュースとして飲む"
    ],
    correctAnswer: 2,
    explanation: "日向夏は、りんごのように黄色い外皮（フラベド）だけを薄くむき、内側にある白いふかふかしたワタ（アルベド）を残して果肉と一緒に食べるのが、最も美味しいとされる食べ方です。"
  },
  {
    id: 53,
    category: "果物",
    question: "なぜ「日向夏」は、白いワタ（アルベド）と一緒に食べることが推奨されているのでしょうか？",
    options: [
      "白いワタに栄養が最も集中しているため",
      "白いワタの苦味が果肉の甘さを引き立てるため",
      "ほんのり甘みのある白いワタが、果肉の酸味を和らげるため",
      "白いワタに独特の香りがあるため"
    ],
    correctAnswer: 2,
    explanation: "日向夏の白いワタ（アルベド）には、ほんのりとした甘みがあります。この甘みが、爽やかな酸味を持つ果肉と合わさることで、酸味がマイルドになり、絶妙な味わいのハーモニーが生まれます。"
  },
  {
    id: 54,
    category: "果物",
    question: "宮崎県内で生産される完熟マンゴーのうち、「太陽のタマゴ」として認定されるのは、およそ何パーセント程度でしょうか？",
    options: [
      "約15%",
      "約30%",
      "約50%",
      "約70%"
    ],
    correctAnswer: 0,
    explanation: "宮崎県で収穫される完熟マンゴーは全て高品質ですが、その中でも「太陽のタマゴ」という称号を得られるのは、全体のわずか15%程度です。"
  },
  {
    id: 55,
    category: "果物",
    question: "完熟きんかん「たまたま」は、ある果物と同じくらいの甘さがあると紹介されています。その果物とは何でしょうか？",
    options: [
      "いちご",
      "ぶどう",
      "完熟マンゴー",
      "メロン"
    ],
    correctAnswer: 2,
    explanation: "完熟きんかん「たまたま」の糖度は16度以上あり、これは完熟マンゴー（特に太陽のタマゴの基準である15度以上）に匹敵するほどの甘さです。"
  },
  {
    id: 56,
    category: "果物",
    question: "完熟きんかん「たまたま」は、2010年以前は別のブランド名で呼ばれていました。その名称は何でしょうか？",
    options: [
      "完熟きんかん「宮崎ゴールド」",
      "完熟きんかん「太陽の子」",
      "完熟きんかん「まるかじり」",
      "完熟きんかん「ひなた美人」"
    ],
    correctAnswer: 2,
    explanation: "現在の「たまたま」というブランド名は、2010年以前は「完熟きんかん まるかじり」という名称で親しまれていました。"
  },
  {
    id: 57,
    category: "果物",
    question: "宮崎県の完熟きんかんは、ブランド化されるために開花結実から一定の日数を樹上で熟成させます。その日数は何日以上とされているでしょうか？",
    options: [
      "150日以上",
      "180日以上",
      "210日以上",
      "240日以上"
    ],
    correctAnswer: 2,
    explanation: "宮崎の完熟きんかんは、花が咲いて実がなってから、樹上で210日以上という長い時間をかけてじっくりと熟成させます。"
  },
  {
    id: 58,
    category: "果物",
    question: "「太陽のタマゴ」の品質基準には、糖度と重さの他に、見た目に関する基準もあります。その品位の基準は何でしょうか？",
    options: [
      "「秀」以上",
      "「優」以上",
      "「青秀」以上",
      "「特秀」のみ"
    ],
    correctAnswer: 2,
    explanation: "「太陽のタマゴ」は、味だけでなく見た目の美しさも重要です。県の統一基準で定められた品位（等級）のうち、傷などが少なく形の良い「青秀」以上のものだけが認定されます。"
  },
  {
    id: 59,
    category: "果物",
    question: "「日向夏」を食べる際、りんごの皮むきのように外皮をむくことが推奨されていますが、その目的は何でしょうか？",
    options: [
      "果肉を傷つけないため",
      "ふかふかの白皮（アルベド）をできるだけ残すため",
      "香りを最大限に引き出すため",
      "手が汚れにくくするため"
    ],
    correctAnswer: 1,
    explanation: "日向夏の美味しさの鍵である白皮（アルベド）を、誤って果肉と一緒に削ぎ落としてしまわないよう、外側の黄色い皮だけを薄くむく方法が推奨されています。"
  },
  {
    id: 60,
    category: "果物",
    question: "宮崎のブランド果物の多くに見られる、糖度や大きさで厳格に階級分けする戦略は、どのような効果をもたらしていると考えられるでしょうか？",
    options: [
      "生産コストを大幅に削減する効果",
      "全ての農家の収入を均一化する効果",
      "客観的な数値基準で品質を保証し、高いブランド価値と信頼を築く効果",
      "収穫時期を自由に調整できる効果"
    ],
    correctAnswer: 2,
    explanation: "糖度、重さ、大きさといった客観的な数値でブランドを階層化する戦略は、消費者に品質の違いを分かりやすく伝え、価格差への納得感を生み出します。これにより、「太陽のタマゴ」や「たまたま」といったブランドへの絶対的な信頼が構築されています。"
  },

  // B. 大地の恵み - 野菜 (問61-70)
  {
    id: 61,
    category: "野菜",
    question: "宮崎県が野菜の中で全国一の生産量を誇るのは、次のうちどれでしょうか？",
    options: [
      "ピーマン",
      "トマト",
      "きゅうり",
      "なす"
    ],
    correctAnswer: 2,
    explanation: "宮崎県はきゅうりの生産量が64,000トンを超え、2位の群馬県を大きく引き離して全国第1位です。"
  },
  {
    id: 62,
    category: "野菜",
    question: "宮崎県は千切り大根の生産量が日本一ですが、その年間生産量はおよそどれくらいでしょうか？",
    options: [
      "500トン～1,000トン",
      "1,000トン～1,500トン",
      "1,500トン～2,000トン",
      "2,500トン～3,000トン"
    ],
    correctAnswer: 3,
    explanation: "宮崎県は日本一の千切り大根の産地であり、その年間生産量は2,500トンから3,000トンにも及びます。"
  },
  {
    id: 63,
    category: "野菜",
    question: "宮崎県の里芋（さといも）の生産量は、全国でトップクラスです。その順位はどれでしょうか？",
    options: [
      "全国1位",
      "全国2位",
      "全国5位",
      "全国10位"
    ],
    correctAnswer: 1,
    explanation: "過去のデータの平均を見ると、宮崎県の里芋の収穫量は千葉県に次いで全国第2位です。"
  },
  {
    id: 64,
    category: "野菜",
    question: "宮崎県の千切り大根や漬物用干し大根の生産において、質の高い製品づくりに貢献している冬の気候的特徴とは何でしょうか？",
    options: [
      "降雪量が多いこと",
      "温暖で湿度が高いこと",
      "日照時間が豊富で、乾燥した「霧島おろし」が吹くこと",
      "昼夜の寒暖差が非常に大きいこと"
    ],
    correctAnswer: 2,
    explanation: "宮崎県の冬は、晴天が多く日照時間が豊富で、山から吹き下ろす冷たく乾燥した風「霧島おろし」が吹きます。この気候が、大根を乾燥させるのに最適です。"
  },
  {
    id: 65,
    category: "野菜",
    question: "宮崎県のきゅうり生産は、主にどの季節に出荷のピークを迎える産地となっているでしょうか？",
    options: [
      "夏",
      "春と秋",
      "冬",
      "一年中均一"
    ],
    correctAnswer: 2,
    explanation: "宮崎県のきゅうり生産の最大の特徴は、温暖な気候を活かした冬春きゅうりです。他の産地の生産が少なくなる冬期に、全国へ安定供給する重要な役割を担っています。"
  },
  {
    id: 66,
    category: "野菜",
    question: "宮崎の冬の風物詩ともいわれる、千切り大根を乾燥させる風景で使われる道具は何でしょうか？",
    options: [
      "ビニールハウス",
      "藁ぶきの小屋",
      "竹のすのこ",
      "鉄製の網棚"
    ],
    correctAnswer: 2,
    explanation: "冬の宮崎の田園風景として有名なのが、収穫した大根を干すための巨大な「大根やぐら」や、千切りにした大根を広げる「竹のすのこ」です。"
  },
  {
    id: 67,
    category: "野菜",
    question: "宮崎県で生産される千切り大根の原料として、主に使われる大根の品種は何でしょうか？",
    options: [
      "聖護院大根",
      "桜島大根",
      "青首大根",
      "練馬大根"
    ],
    correctAnswer: 2,
    explanation: "宮崎県で生産される千切り大根の原料には、主に甘みが強く、加工に適した青首大根が使用されています。"
  },
  {
    id: 68,
    category: "野菜",
    question: "宮崎県の大根は、利用の仕方によって青果用と加工用に分けられますが、宮崎県で特に生産が盛んなのはどちらでしょうか？",
    options: [
      "青果用",
      "加工用",
      "ほぼ同量",
      "統計はない"
    ],
    correctAnswer: 1,
    explanation: "宮崎県の大根生産は、漬物用の干し大根や千切り大根といった加工用の生産が非常に盛んであることが大きな特徴です。"
  },
  {
    id: 69,
    category: "野菜",
    question: "2023年までの過去データ平均による里芋の生産量ランキングで、宮崎県に次いで全国3位の都道府県はどこでしょうか？",
    options: [
      "千葉県",
      "埼玉県",
      "鹿児島県",
      "栃木県"
    ],
    correctAnswer: 1,
    explanation: "2023年までの過去データ平均による里芋の生産量ランキングは、1位が千葉県、2位が宮崎県、3位が埼玉県となっています。"
  },
  {
    id: 70,
    category: "野菜",
    question: "宮崎県が冬のきゅうり生産で全国一であることは、日本の食料供給においてどのような役割を果たしていると考えられるでしょうか？",
    options: [
      "夏野菜であるきゅうりの価格を年間通して安定させる役割",
      "他の産地が出荷できない時期に供給を担う、重要な補完的役割",
      "きゅうりの輸入量を減らすための国策としての役割",
      "加工用きゅうりの主要な供給源としての役割"
    ],
    correctAnswer: 1,
    explanation: "多くの野菜産地が寒さで生産を休止する冬期に、宮崎県が温暖な気候を活かしてきゅうりを大量に供給することで、年間を通じたきゅうりの安定供給が実現しています。"
  },

  // 第3部 黒潮からの恵みと革新 - A. 黒潮の幸 (問71-80)
  {
    id: 71,
    category: "水産業",
    question: "宮崎県が長年にわたり漁獲量日本一を誇る、近海での漁業は何でしょうか？",
    options: [
      "まき網漁業",
      "底引き網漁業",
      "かつお一本釣り漁業",
      "定置網漁業"
    ],
    correctAnswer: 2,
    explanation: "宮崎県は、近海かつお一本釣り漁業の漁獲量において、長年にわたり日本一の座を守り続けています。特に日南市がその中心地として全国的に有名です。"
  },
  {
    id: 72,
    category: "水産業",
    question: "宮崎県のかつお一本釣り漁業は、どれくらいの期間、漁獲量日本一を維持しているでしょうか？",
    options: [
      "約5年間",
      "約10年間",
      "15年以上",
      "四半世紀（25年）以上"
    ],
    correctAnswer: 3,
    explanation: "宮崎県日南市を中心とした近海かつお一本釣り漁業は、四半世紀、つまり25年以上にわたって漁獲量日本一を維持しています。"
  },
  {
    id: 73,
    category: "水産業",
    question: "宮崎県のかつお一本釣り漁業の中心的な基地となっている漁港は、主にどの市にあるでしょうか？",
    options: [
      "宮崎市",
      "延岡市",
      "日南市",
      "串間市"
    ],
    correctAnswer: 2,
    explanation: "宮崎県のかつお一本釣り漁業は、日南市の南郷町にある目井津（めいつ）漁港などが中心的な水揚げ港となっています。"
  },
  {
    id: 74,
    category: "水産業",
    question: "かつお一本釣り漁で、かつおの群れを興奮させて釣るために、船から撒かれるものは何でしょうか？",
    options: [
      "生きたカタクチイワシ",
      "乾燥したオキアミ",
      "人工の撒き餌",
      "魚の内臓"
    ],
    correctAnswer: 0,
    explanation: "かつおの群れを見つけると、生きたカタクチイワシを撒き餌として海に撒きます。これにより、かつおの群れが興奮状態（ナブラ）になり、疑似餌にも食いつきやすくなります。"
  },
  {
    id: 75,
    category: "水産業",
    question: "延岡市北浦町で養殖されている宮崎県のブランド魚「ひむか本サバ」の最大の特徴として挙げられることは何でしょうか？",
    options: [
      "脂が非常に多いこと",
      "無投薬で育てられ、刺身でも食べられるほどの鮮度と味であること",
      "骨が少なく加工しやすいこと",
      "1年を通して安定して出荷できること"
    ],
    correctAnswer: 1,
    explanation: "「ひむか本サバ」は、延岡市北浦のきれいな海で、病気を防ぐための投薬を一切行わずに、手間ひまかけて育てられた養殖サバです。そのため、サバ特有の臭みがなく、身の締まりも良いため、刺身や寿司といった生食でその真価を発揮します。"
  },
  {
    id: 76,
    category: "水産業",
    question: "かつお一本釣り漁法は、およそ300年前にどの藩からこの地域に伝わったとされているでしょうか？",
    options: [
      "土佐藩",
      "長州藩",
      "薩摩藩",
      "紀州藩"
    ],
    correctAnswer: 3,
    explanation: "日南市に伝わるかつお一本釣り漁法は、今からおよそ300年前の江戸時代に、現在の和歌山県にあたる紀州藩から漁師が移り住み、その技術を伝えたのが始まりとされています。"
  },
  {
    id: 77,
    category: "水産業",
    question: "「ひむか本サバ」の美味しさについて、提供する店が「とにかく、そのまま食べるのがイチバン」と勧めるほどの食べ方は何でしょうか？",
    options: [
      "焼き魚",
      "煮付け",
      "刺身",
      "フライ"
    ],
    correctAnswer: 2,
    explanation: "「ひむか本サバ」は、適度な脂のりと、しっかりとした身の旨味が特徴です。その素材の良さを最も味わえる食べ方として、地元の飲食店などでは刺身が一番に推奨されています。"
  },
  {
    id: 78,
    category: "水産業",
    question: "かつお一本釣り漁船は、漁獲したかつおの鮮度を保つために、ある性能が特に重視されます。それは何でしょうか？",
    options: [
      "船体の大きさ",
      "燃料タンクの容量",
      "快速性（スピード）",
      "船の静粛性"
    ],
    correctAnswer: 2,
    explanation: "かつおは鮮度が命の魚です。そのため、漁を終えたかつお船は、一刻も早く港に戻って水揚げする必要があります。このため、かつお船には強力なエンジンが搭載され、高い快速性が求められます。"
  },
  {
    id: 79,
    category: "水産業",
    question: "「ひむか本サバ」は、刺身や寿司の他に、どのような調理法でも美味しいと紹介されているでしょうか？",
    options: [
      "燻製",
      "しめサバ、焼き、揚げ物",
      "干物",
      "スープの出汁"
    ],
    correctAnswer: 1,
    explanation: "「ひむか本サバ」は、刺身だけでなく、しめサバにしても美味しく、また焼いても揚げてもその旨味を堪能できる、非常に万能な魚です。"
  },
  {
    id: 80,
    category: "水産業",
    question: "宮崎県が伝統的な「かつお一本釣り」で日本一を維持していることは、漁業において何を意味しているでしょうか？",
    options: [
      "最新の乱獲型漁業への移行が遅れていること",
      "資源管理と品質維持を両立させる持続可能な漁法が今も高く評価されていること",
      "漁業従事者の高齢化が進んでいること",
      "燃料効率の悪い漁法が主流であること"
    ],
    correctAnswer: 1,
    explanation: "一本釣りは、網で一網打尽にする漁法と比べて、魚を傷つけにくく高品質を保てる上、必要な分だけを釣るため、資源に優しい持続可能な漁法とされています。宮崎県がこの漁法でトップを維持していることは、効率だけでなく、品質と持続可能性を重視する漁業が評価されている証です。"
  },

  // B. 革新の養殖 (問81-85)
  {
    id: 81,
    category: "水産業",
    question: "宮崎県が生産する高級食材「宮崎キャビア1983」。この「1983」という数字は何に由来しているでしょうか？",
    options: [
      "キャビアが初めて商品化された年",
      "宮崎県でチョウザメの養殖研究が始まった年",
      "チョウザメの親魚がロシアから贈られた年",
      "ブランドの商標登録番号"
    ],
    correctAnswer: 1,
    explanation: "「宮崎キャビア1983」のブランド名は、宮崎県水産試験場でチョウザメの研究が開始された1983年に由来します。"
  },
  {
    id: 82,
    category: "水産業",
    question: "「宮崎キャビア1983」の原材料として使われているのは、チョウザメの魚卵と何でしょうか？",
    options: [
      "食塩のみ",
      "食塩と保存料",
      "食塩とハーブ",
      "食塩と白ワイン"
    ],
    correctAnswer: 0,
    explanation: "「宮崎キャビア1983」は、宮崎県産の新鮮なチョウザメの卵を、岩塩のみでシンプルに味付けして熟成させています。保存料などを一切使用せず、卵本来のクリーミーで濃厚な旨味を最大限に引き出しています。"
  },
  {
    id: 83,
    category: "水産業",
    question: "宮崎県は2004年、国内で初めてある種類のチョウザメの完全養殖に成功しました。そのチョウザメの種類は何でしょうか？",
    options: [
      "ロシアチョウザメ",
      "シベリアチョウザメ",
      "シロチョウザメ",
      "コチョウザメ"
    ],
    correctAnswer: 2,
    explanation: "宮崎県水産試験場は、長年の研究の末、2004年に国内で初めてシロチョウザメの完全養殖（人工ふ化させた稚魚を親魚まで育て、その親魚から採卵・受精させて次の世代を生み出す技術）に成功しました。"
  },
  {
    id: 84,
    category: "水産業",
    question: "「宮崎キャビア1983」は、その品質の高さから、ある航空会社のファーストクラスで初めて採用された国産キャビアとなりました。その航空会社はどこでしょうか？",
    options: [
      "日本航空（JAL）",
      "全日本空輸（ANA）",
      "スカイマーク",
      "スターフライヤー"
    ],
    correctAnswer: 1,
    explanation: "「宮崎キャビア1983」は、その高い品質と安全性が評価され、国産キャビアとして初めてANA（全日本空輸）の国際線ファーストクラスの機内食に採用されました。"
  },
  {
    id: 85,
    category: "水産業",
    question: "宮崎県でチョウザメ養殖研究が始まったきっかけは何だったでしょうか？",
    options: [
      "天皇陛下のご視察",
      "県独自の開発プロジェクト",
      "旧ソ連から日ソ友好の証として贈られたチョウザメの分与",
      "アメリカからの技術提供"
    ],
    correctAnswer: 2,
    explanation: "1983年、旧ソ連（現在のロシア）から日ソ友好の証として日本にチョウザメが贈られ、その一部が宮崎県水産試験場に分与されたことが、研究の始まりでした。"
  },

  // 第4部 森の恵みと匠の技 - A. 林業 (問86-90)
  {
    id: 86,
    category: "林業",
    question: "宮崎県は、ある樹木の素材（丸太）生産量において、平成3年（1991年）以降、30年以上にわたって連続日本一を達成しています。その樹木とは何でしょうか？",
    options: [
      "ヒノキ",
      "スギ",
      "マツ",
      "ケヤキ"
    ],
    correctAnswer: 1,
    explanation: "宮崎県は日本有数の林業県であり、特にスギの素材（丸太）生産量においては、平成3年（1991年）から令和5年（2023年）まで33年連続で日本一を達成しています。"
  },
  {
    id: 87,
    category: "林業",
    question: "宮崎県南部で生産される「飫肥杉（おびすぎ）」は、かつてある特定の用途の木材「弁甲材（べんこうざい）」として高く評価されていました。その用途とは何でしょうか？",
    options: [
      "神社仏閣の柱",
      "木造船の材料",
      "鉄道の枕木",
      "家具"
    ],
    correctAnswer: 1,
    explanation: "飫肥杉は、樹脂分が多くて水に強く、軽くて丈夫な性質から、江戸時代から木造船の材料である「弁甲材」として非常に重宝されました。"
  },
  {
    id: 88,
    category: "林業",
    question: "「飫肥杉」が船の材料として適していた理由として、その材質の特徴が挙げられます。次のうち、当てはまらないものはどれでしょうか？",
    options: [
      "樹脂を多く含み吸水性が低い",
      "年輪幅が広く軽い",
      "衝撃で割れにくい強度がある",
      "非常に硬く重い"
    ],
    correctAnswer: 3,
    explanation: "飫肥杉の材質的な特徴は、年輪幅が広く成長が早いため、比重が小さく「軽い」ことです。硬くて重いのではなく、軽くて強度があるという特性が、船材としての価値を高めました。"
  },
  {
    id: 89,
    category: "林業",
    question: "令和5年（2023年）の木材統計によると、宮崎県のスギ素材生産量は全国1位ですが、県全体の素材生産量（スギ以外も含む）は全国で第何位でしょうか？",
    options: [
      "第1位",
      "第2位",
      "第3位",
      "第5位"
    ],
    correctAnswer: 1,
    explanation: "宮崎県はスギ素材生産量では圧倒的な1位ですが、ヒノキや広葉樹などを含めた県全体の素材生産量では、広大な森林を持つ北海道に次いで全国第2位となっています。"
  },
  {
    id: 90,
    category: "林業",
    question: "「弁甲材」とは、どのような形状に加工された木材を指す言葉でしょうか？",
    options: [
      "四角い角材",
      "薄い板状",
      "丸太の上下を平らに削ったもの",
      "細かく砕いたチップ状"
    ],
    correctAnswer: 2,
    explanation: "「弁甲材」は、山から切り出した丸太を、運搬しやすく、また船上で扱いやすいように、上下（天地）を斧などで平らに削り落とした木材のことを指します。"
  },

  // B. 本格焼酎 (問91-95)
  {
    id: 91,
    category: "本格焼酎",
    question: "宮崎県は、鹿児島県と並ぶ本格焼酎の産地ですが、本格焼酎の出荷量において、長年どちらが全国1位を維持しているでしょうか？",
    options: [
      "宮崎県",
      "鹿児島県",
      "ほぼ毎年入れ替わっている",
      "大分県"
    ],
    correctAnswer: 0,
    explanation: "本格焼酎の二大産地である宮崎県と鹿児島県ですが、出荷量においては、宮崎県が2014年以降、長年にわたって連続で全国1位を維持しています。"
  },
  {
    id: 92,
    category: "本格焼酎",
    question: "宮崎県が本格焼酎の魅力を国内外に発信するために掲げているテーマは何でしょうか？",
    options: [
      "「焼酎を日本の國酒に」",
      "「焼酎を世界の宝に」",
      "「焼酎で健康な毎日を」",
      "「焼酎と宮崎料理の融合」"
    ],
    correctAnswer: 1,
    explanation: "宮崎県は、本格焼酎を日本国内だけでなく、世界に通用する蒸留酒としてその魅力を発信するため、「焼酎を世界の宝に」をテーマに掲げ、国際的なプロモーション活動を積極的に行っています。"
  },
  {
    id: 93,
    category: "本格焼酎",
    question: "2020年7月から2021年6月までの1年間における宮崎県の本格焼酎出荷量は、およそどれくらいでしょうか？",
    options: [
      "約5万キロリットル",
      "約9万4千キロリットル",
      "約11万6千キロリットル",
      "約15万キロリットル"
    ],
    correctAnswer: 2,
    explanation: "日本酒造組合中央会の発表によると、2020年7月から2021年6月までの1年間で、宮崎県は約11万6626キロリットルの本格焼酎を出荷しました。"
  },
  {
    id: 94,
    category: "本格焼酎",
    question: "宮崎県と県酒造組合が、新たな焼酎ファン獲得のために共同で作成したPRツールの一つに、世界初の焼酎カクテルのみを収録したレシピブックがあります。その名称は何でしょうか？",
    options: [
      "宮崎本格焼酎だれやみBOOK",
      "宮崎焼酎カクテルBOOK",
      "世界へ羽ばたく宮崎焼酎",
      "SHOCHU INNOVATION 100"
    ],
    correctAnswer: 1,
    explanation: "宮崎県と県酒造組合は、焼酎の新たな楽しみ方を提案するため、国内外の著名なバーテンダーと協力し、世界で初めて焼酎ベースのカクテルだけを集めた「宮崎焼酎カクテルBOOK」を日英併記で作成しました。"
  },
  {
    id: 95,
    category: "本格焼酎",
    question: "宮崎県が焼酎のプロモーションで特にアプローチしようとしている、焼酎になじみの薄い層として挙げられているのは、次のうちどれでしょうか？",
    options: [
      "高齢者層",
      "農業従事者",
      "若者・女性、外国人",
      "首都圏の富裕層"
    ],
    correctAnswer: 2,
    explanation: "従来の焼酎ファンだけでなく、新たな層にその魅力を伝えるため、県は特に若者や女性、そして外国人といった、これまで焼酎にあまり馴染みがなかった層へのアプローチを強化しています。"
  },

  // 第5部 農業を支えるシステム・歴史・文化 - A. 試練と復興 (問96-98)
  {
    id: 96,
    category: "歴史・文化",
    question: "2010年に宮崎県の畜産業を襲い、甚大な被害をもたらした家畜の伝染病は何でしょうか？",
    options: [
      "鳥インフルエンザ",
      "豚熱（CSF）",
      "口蹄疫",
      "狂牛病（BSE）"
    ],
    correctAnswer: 2,
    explanation: "2010年4月に発生した口蹄疫は、宮崎県の畜産業、特に牛と豚に壊滅的な被害をもたらしました。"
  },
  {
    id: 97,
    category: "歴史・文化",
    question: "2010年の口蹄疫の発生により、宮崎県内で殺処分の対象となった牛・豚の数はおよそ何万頭にのぼったでしょうか？",
    options: [
      "約10万頭",
      "約20万頭",
      "約30万頭",
      "約50万頭"
    ],
    correctAnswer: 2,
    explanation: "2010年の口蹄疫では、感染拡大防止のために、発生農場およびその周辺地域の牛や豚、約30万頭（29万7808頭）が殺処分されました。"
  },
  {
    id: 98,
    category: "歴史・文化",
    question: "口蹄疫からの復興を祈念し、処分された家畜の鎮魂と未来への希望を込めて「口蹄疫復興祈念の森」が造成されました。この森があるのは宮崎県のどの町でしょうか？",
    options: [
      "都農町",
      "川南町",
      "新富町",
      "高鍋町"
    ],
    correctAnswer: 1,
    explanation: "口蹄疫で特に甚大な被害を受けた地域の一つである川南町に、この悲劇を忘れず、復興への誓いを新たにするため、「口蹄疫復興祈念の森」が造成されました。"
  },

  // B. 伝統の継承 (問99-100)
  {
    id: 99,
    category: "歴史・文化",
    question: "宮崎県北部の高千穂郷・椎葉山地域は、2015年にその伝統的な農林業システムが世界的に評価され、ある認定を受けました。それは何でしょうか？",
    options: [
      "ユネスコ無形文化遺産",
      "世界農業遺産",
      "日本農業遺産",
      "ラムサール条約湿地"
    ],
    correctAnswer: 1,
    explanation: "宮崎県北部の高千穂郷・椎葉山地域は、急峻な山間地で自然と共生しながら、伝統的な農林業や文化を維持してきた「山間地農林業複合システム」が高く評価され、2015年に国連食糧農業機関（FAO）から世界農業遺産（GIAHS）に認定されました。"
  },
  {
    id: 100,
    category: "歴史・文化",
    question: "高千穂郷・椎葉山地域が世界農業遺産に認定された理由である「山間地農林業複合システム」。その構成要素として、適切でないものは次のうちどれでしょうか？",
    options: [
      "総延長500km以上の山腹水路網と棚田",
      "大規模なダムを利用した近代的な灌漑農業",
      "スギや照葉樹林などが織りなす「モザイク林」での林業",
      "現在も続く伝統的な焼畑農業や神楽などの伝統文化"
    ],
    correctAnswer: 1,
    explanation: "高千穂郷・椎葉山地域の世界農業遺産認定の核心は、近代的な大規模開発ではなく、伝統的な手法の継承にあります。山腹に張り巡らされた水路網や棚田、多様な樹木が共存するモザイク林、そして焼畑といった、自然の力を巧みに利用した持続可能なシステムが評価の対象です。"
  }
];
